import { environment } from '../../../environments/environment';

function safeEncodeUrl(url: string): string {
  const match = url.match(/^(https?:\/\/[^\/?#]+)([^?#]*)(\?[^#]*)?(#.*)?$/i);
  if (!match) return encodeURI(url);
  const [, origin, path, query = '', hash = ''] = match;
  const encodedPath = path
    .split('/')
    .map((segment) => {
      const raw = segment || '';
      try {
        return encodeURIComponent(decodeURIComponent(raw));
      } catch {
        return encodeURIComponent(raw);
      }
    })
    .join('/')
    .replace(/%2F/g, '/');
  return `${origin}${encodedPath}${query}${hash}`;
}

/**
 * URL absoluta para ficheiros servidos pela API (`/storage/...`, paths relativos).
 * Alinhado às configurações da empresa (logo) e às capas de projeto.
 */
export function resolveApiAssetUrl(assetUrl: string | null | undefined): string {
  const value = (assetUrl ?? '').trim();
  if (!value) return '';
  if (/^https?:\/\//i.test(value)) return safeEncodeUrl(value);
  if (value.startsWith('data:')) return value;

  const normalized = value.replace(/\\/g, '/').replace(/\/{2,}/g, '/');
  const base = environment.apiUrl.replace(/\/$/, '');
  const suffix = normalized.startsWith('/storage/')
    ? normalized
    : normalized.startsWith('storage/')
      ? `/${normalized}`
      : normalized.startsWith('/')
        ? normalized
        : `/storage/${normalized}`;
  return safeEncodeUrl(`${base}${suffix}`);
}

/**
 * URL absoluta para recursos da API quando o path pode ser qualquer rota relativa
 * (ex.: avatar de utilizador em `/storage/...` ou outro path devolvido pelo backend).
 * Não força prefixo `/storage/` em paths relativos sem barra inicial.
 */
export function resolveHttpOrRelativeApiUrl(raw: string | null | undefined): string {
  const t = (raw ?? '').trim();
  if (!t) return '';
  if (t.startsWith('data:') || t.startsWith('blob:')) return t;
  if (/^https?:\/\//i.test(t)) return safeEncodeUrl(t);
  const base = environment.apiUrl.replace(/\/$/, '');
  const path = t.startsWith('/') ? t : `/${t}`;
  return safeEncodeUrl(`${base}${path}`);
}
